import { z } from "zod";
import { AggregationMethodEnum } from "./timeseries.js";
import { zArr, zBool, zNullable, zNum, zObj, zStr } from "./zodWrapper.js";
import { JsonData } from "./common.js";
export var SignalBaseLine;
(function (SignalBaseLine) {
    SignalBaseLine["MIN"] = "MIN";
    SignalBaseLine["MAX"] = "MAX";
    SignalBaseLine["AVERAGE"] = "AVERAGE";
})(SignalBaseLine || (SignalBaseLine = {}));
export const SignalBaseLineEnum = z.nativeEnum(SignalBaseLine);
export var SensorThresholdType;
(function (SensorThresholdType) {
    SensorThresholdType["MIN"] = "MIN";
    SensorThresholdType["MAX"] = "MAX";
})(SensorThresholdType || (SensorThresholdType = {}));
export const SensorThresholdTypeEnum = z.nativeEnum(SensorThresholdType);
export var PlotType;
(function (PlotType) {
    PlotType["PLOT"] = "PLOT";
    PlotType["CARD"] = "CARD";
})(PlotType || (PlotType = {}));
export const PlotTypeEnum = z.nativeEnum(PlotType);
export const User = zObj({
    roles: zArr(zStr()),
    name: zStr(),
    email: zStr(),
    affiliation: zStr(),
    profileImgUrl: zStr(),
});
// plots
export const PlantPlotsGetArgs = zObj({
    type: PlotTypeEnum,
    plantId: zNum(),
    assetId: zNullable(zNum()),
    groupId: zNullable(zNum()),
});
export const AnyPlantPlotsGetArgs = zObj({ plotGroupId: zNum(), plantId: zNum() });
export const AnyPlantPlotSignal = zObj({
    id: zNum(),
    sensorId: zNum(),
});
export const AnyPlantPlot = zObj({ id: zNum(), signals: zArr(AnyPlantPlotSignal), name: zNullable(zStr()) });
export const SensorThreshold = zObj({
    id: zNum(),
    name: zStr(),
    value: zNum(),
    type: SensorThresholdTypeEnum,
    useAlarm: zBool(),
});
export const PlantPlotSignal = zObj({
    id: zNum(),
    sensorId: zNum(),
    aggregationMethod: AggregationMethodEnum,
    baselines: zArr(SignalBaseLineEnum),
    thresholds: zArr(SensorThreshold),
    color: zStr(),
});
export const PlantPlotAddArgs = zObj({
    type: PlotTypeEnum,
    plantId: zNum(),
    assetId: zNullable(zNum()),
    groupId: zNullable(zNum()),
    signals: zArr(PlantPlotSignal),
    name: zNullable(zStr()),
});
export const PlantPlotRemoveArgs = zObj({ id: zNum() });
export const PlantPlotUpdateArgs = zObj({ id: zNum(), signals: zArr(PlantPlotSignal), name: zNullable(zStr()) });
export const AnyPlantPlotUpdateArgs = zObj({ id: zNum(), signals: zArr(AnyPlantPlotSignal), name: zNullable(zStr()), plotGroupId: zNum() });
export const AnyPlantPlotGroupRenameArgs = zObj({ id: zNum(), name: zStr() });
export const AnyPlantPlotGroupUpdateArgs = zObj({ id: zNum(), plots: zArr(AnyPlantPlot), name: zStr() });
export const AnyPlantPlotGroupDeleteArgs = zObj({ id: zNum() });
export const AnyPlantPlotAddArgs = zObj({ signals: zArr(AnyPlantPlotSignal), name: zStr(), plotGroupId: zNum() });
export const AnyPlantPlotGroupAddArgs = zObj({ name: zStr() });
export const AnyPlantPlotGroupAdd = zObj({ id: zNum() });
export const AnyPlantPlotDeleteArgs = zObj({ id: zNum() });
export const AnyPlantPlotAdd = zObj({
    id: zNum(),
});
export const PlantPlot = zObj({ id: zNum(), signals: zArr(PlantPlotSignal), name: zNullable(zStr()) });
export const PlantPlotCollection = zObj({ plots: zArr(PlantPlot) });
export const PlantPlotResetArgs = zObj({
    type: PlotTypeEnum,
    plantId: zNum(),
    assetId: zNullable(zNum()),
    groupId: zNullable(zNum()),
    addDefaults: zBool(),
});
export const PlantSetMetaDataArgs = z.object({
    plantId: zNum(),
    data: z.nullable(JsonData),
});
//# sourceMappingURL=admin.js.map